import React from 'react';
import './index.scss';
import Footer from '../Footer';
import Activity from '../Activity';
import fitDanceAdultosImg from '../../assets/img/dance_optimized/IMG_8671.JPG';
import fitDanceKidsMañana from '../../assets/img/dance_optimized/IMG_1712.JPG';
import fitDanceKidsIImg from '../../assets/img/dance_optimized/IMG_8020.JPG';
import fitDanceKidsIIImg from '../../assets/img/dance_optimized/IMG_1696.JPG';
import fitDanceKidsTeensImg from '../../assets/img/dance_optimized/c40d4905-405c-4cc3-9494-c1ea99db3f10.jpg';
import fitDanceStreetBImg from '../../assets/img/dance_optimized/IMG_1603.JPG';
import fitDanceStreetAImg from '../../assets/img/dance_optimized/IMG_1614.JPG';
import fitDanceStreetTeensImg from '../../assets/img/dance_optimized/IMG_1606.JPG';
import fitDanceSalsaImg from '../../assets/img/dance_optimized/IMG_9194.jpg';
import fitDanceBachataImg from '../../assets/img/dance_optimized/IMG_8719.JPG';
import fusionDanceImg from '../../assets/img/IMG_funsion-dance.JPG';
import desafiARTE from '../../assets/img/IMG_3891.png';

const class1 = {
  image: fitDanceAdultosImg,
  title: 'Fit Dance adultos',
  desc: 'Fit Dance conjuga entrenamiento y danza, convirtiéndola en una actividad aeróbica, divertida y placentera, utilizando el baile como eje motivador. Se destaca el trabajo con coreografías ideadas y pensadas en relación a la forma musical que acompaña el ejercicio y el movimiento, utilizando determinados músculos y posturas corporales. Durante la clase, se suceden distintas intensidades de trabajo que generan cambios en la frecuencia cardíaca.',
  prof: [
    {
      name: 'Virginia Borgna',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: '17 años en adelante.',
    dateTime:
      'Lunes y Miércoles 8:00hs / Martes y Jueves 13:15hs | Lunes a Jueves 19:30hs',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class2 = {
  image: fitDanceKidsMañana,
  title: 'Dance Kids I',
  desc: 'Dance conjuga entrenamiento y danza, convirtiéndola en una actividad aeróbica, divertida y placentera, utilizando el baile como eje motivador. Se destaca el trabajo con coreografías ideadas y pensadas en relación a la forma musical que acompaña el ejercicio y el movimiento, utilizando determinados músculos y posturas corporales. Durante la clase, se suceden distintas intensidades de trabajo que generan cambios en la frecuencia cardíaca.',
  prof: [
    {
      name: 'Malena Junco',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'De 3 a 6 años.',
    dateTime: 'Lunes y Miércoles 10:30h en Bv. Santa Fe 1158 / Martes y Jueves 17:30h en Av. Italia 153',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'https://forms.gle/dSMxbh5SCMXumBEK7',
  location: 'Bv. Santa Fe 1158 o Av. Italia 153, Rafaela, Santa Fe',
};

const class3 = {
  image: fitDanceKidsIImg,
  title: 'Dance Kids II',
  desc: 'Dance conjuga entrenamiento y danza, convirtiéndola en una actividad aeróbica, divertida y placentera, utilizando el baile como eje motivador. Se destaca el trabajo con coreografías ideadas y pensadas en relación a la forma musical que acompaña el ejercicio y el movimiento, utilizando determinados músculos y posturas corporales. Durante la clase, se suceden distintas intensidades de trabajo que generan cambios en la frecuencia cardíaca.',
  prof: [
    {
      name: 'Malena Junco',
      img: fitDanceAdultosImg,
    },
    {
      name: 'Mai Servann',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'De 7 a 9 años.',
    dateTime: 'Martes y Jueves 10:30h / Martes y Jueves 18:30h ',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'https://forms.gle/dSMxbh5SCMXumBEK7',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class4 = {
  image: fitDanceKidsIIImg,
  title: 'Dance pre teens',
  desc: 'Dance conjuga entrenamiento y danza, convirtiéndola en una actividad aeróbica, divertida y placentera, utilizando el baile como eje motivador. Se destaca el trabajo con coreografías ideadas y pensadas en relación a la forma musical que acompaña el ejercicio y el movimiento, utilizando determinados músculos y posturas corporales. Durante la clase, se suceden distintas intensidades de trabajo que generan cambios en la frecuencia cardíaca.',
  prof: [
    {
      name: 'Malena Junco',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'De 10 a 12 años.',
    dateTime: 'Martes y Jueves 18:30h',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'https://forms.gle/dSMxbh5SCMXumBEK7',
  location: 'Av. Italia 153, Rafaela, Santa Fe',
};

const class5 = {
  image: fitDanceKidsTeensImg,
  title: 'Dance teens',
  desc: 'Dance conjuga entrenamiento y danza, convirtiéndola en una actividad aeróbica, divertida y placentera, utilizando el baile como eje motivador. Se destaca el trabajo con coreografías ideadas y pensadas en relación a la forma musical que acompaña el ejercicio y el movimiento, utilizando determinados músculos y posturas corporales. Durante la clase, se suceden distintas intensidades de trabajo que generan cambios en la frecuencia cardíaca.',
  prof: [
    {
      name: 'Malena Junco',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'De 13 a 15 años.',
    dateTime: 'Martes y Jueves 19:30h',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'hhttps://forms.gle/dSMxbh5SCMXumBEK7',
  location: 'Av. Italia 153, Rafaela, Santa Fe',
};

const class6 = {
  image: fitDanceStreetBImg,
  title: 'Street Dance adultos principiantes',
  desc: 'Street Dance es una actividad en la que se aprende y entrena diversas coreografías fusionando diferentes lenguajes y estilos, entre ellos hip hop, dancehall, reggaetón (fusión), jazz funk, tutting, femme, entre otros; comprendiendo tanto movimientos libres y fluidos como lineales y técnicos. A través de ejercicios técnicos entrenamos la disociación, memorización y control del cuerpo. Las coreografías se preparan en base al nivel de los grupos y tiene como objetivo aprender, superarse, divertirse y compartir.',
  prof: [
    {
      name: 'Natalia Reynaudo',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'Sin limite.',
    dateTime: 'Lunes y Miércoles 14:30h | Martes y Jueves 16:30h',
    duration: '1h',
    wpp: '5493401416919',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class7 = {
  image: fitDanceStreetAImg,
  title: 'Street Dance adultos intermedio',
  desc: 'Street Dance es una actividad en la que se aprende y entrena diversas coreografías fusionando diferentes lenguajes y estilos, entre ellos hip hop, dancehall, reggaetón (fusión), jazz funk, tutting, femme, entre otros; comprendiendo tanto movimientos libres y fluidos como lineales y técnicos. A través de ejercicios técnicos entrenamos la disociación, memorización y control del cuerpo. Las coreografías se preparan en base al nivel de los grupos y tiene como objetivo aprender, superarse, divertirse y compartir.',
  prof: [
    {
      name: 'Natalia Reynaudo',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'Sin limite.',
    dateTime: 'Martes y Jueves 20:30hs.',
    duration: '1h',
    wpp: '5493401416919',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class8 = {
  image: fitDanceSalsaImg,
  title: 'Bachata en pareja',
  desc: 'Tanto en bachata como en salsa se trabaja en pareja e individualmente. Las clases son muy dinámicas, se aprende la técnica individual y básica de cada ritmo. No es necesario venir con pareja.',
  prof: [
    {
      name: 'Roxana Arrieta',
      img: fitDanceAdultosImg,
    },
    {
      name: 'Cristian Andres',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'Sin limite.',
    dateTime: 'Martes 21:30hs.',
    duration: '1h',
    wpp: '5493492595321',
  },
  enroll: '',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class9 = {
  image: fitDanceBachataImg,
  title: 'Bachata pasos sueltos',
  desc: 'Tanto en bachata como en salsa se trabaja en pareja e individualmente. Las clases son muy dinámicas, se aprende la técnica individual y básica de cada ritmo. No es necesario venir con pareja.',
  prof: [
    {
      name: 'Roxana Arrieta',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'Sin limite.',
    dateTime: 'Miércoles 20:30hs.',
    duration: '1h',
    wpp: '5493492565355',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const class10 = {
  image: fusionDanceImg,
  title: 'Folklore - Roni Latido Ancestral Folk',
  desc: 'Una clase única para conectar con la herencia cultural y liberar emociones a través de la danza folclórica. Movimiento, tradición y energía ancestral en un solo lugar.',
  prof: [],
  charac: {
    ages: 'Todas las edades',
    dateTime: 'Jueves 20;30hs',
    duration: '1h',
    wpp: '5493492289969',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Av. Italia 153, Rafaela, Santa Fe.',
};

const class11 = {
  image: fitDanceStreetTeensImg,
  title: 'Danza escénica',
  desc: 'Actividad en la que se aprende y entrena diversas coreografías fusionando diferentes lenguajes y estilos, entre ellos hip hop, dancehall, reggaetón (fusión), jazz funk, tutting, femme, entre otros; comprendiendo tanto movimientos libres y fluidos como lineales y técnicos. A través de ejercicios técnicos entrenamos la disociación, memorización y control del cuerpo. Las coreografías se preparan en base al nivel de los grupos y tiene como objetivo aprender, superarse, divertirse y compartir.',
  prof: [],
  charac: {
    ages: 'A partir de los 16 años.',
    dateTime: 'Miércoles y Viernes 17:30h',
    duration: '1h',
    wpp: '5493401416919',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe.',
};

const class12 = {
  image: desafiARTE,
  title: 'Taller DESAFIARTE',
  desc: 'DesafiARTE es un espacio recreativo destinado a personas con discapacidad, a partir de los 18 años. Se busca promover y potenciar el autoconocimiento, a través de la participación en actividades de ocio y conectando con el arte. Las propuestas están pensadas en la participación plena de todos, por lo que se tendrán en cuenta las singularidades de cada adulto. En desafiARTE apostamos al aprendizaje desde la experiencia con otros para autoconocernos, disfrutar, potenciar habilidades sociales, motrices, estimular los sentidos y de esta manera ENCONTRAR TALENTOS en cada persona, desde el trabajo en grupo.',
  prof: [
    {
    name: 'Candela Innocenti (acompañante terapéutica)',
    img: fitDanceAdultosImg,
    },
    {
      name: 'Emilia Basano (terapista ocupacional)',
      img: fitDanceAdultosImg,
    },
  ],
  charac: {
    ages: 'De 18 años en adelante',
    dateTime: 'Viernes 16:30hs.',
    duration: '1h 30min',
    wpp: '5493492289969',
  },
  enroll: 'https://wa.me/message/5SMDQRAXT42ZM1',
  location: 'Bv. Santa Fe 1158, Rafaela, Santa Fe',
};

const Dance = () => {
   const classes = [
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      class7,
      class8,
      class9,
      class10,
      class11,
      class12,
   ];
   return (
    <>
      <div className='dance-container'>
        <div className='header-bg'></div>
        <div className='dance-title'>
          <article>
            <h1>CLASES DE BAILE</h1>
          </article>
        </div>
        <div className='dance-content'>
          <div className='cards-container'>
            {classes.map((element, i) => (
              <Activity
                classImg={element.image}
                classTitle={element.title}
                classDescription={element.desc}
                professors={element.prof}
                ages={element.charac.ages}
                dateTime={element.charac.dateTime}
                duration={element.charac.duration}
                wpp={element.charac.wpp}
                enroll={element.enroll}
                location={element.location}
                key={`${element.wpp}_${i}`}
              />
            ))}
          </div>
        </div>
      </div>

      <footer>
        <Footer />
      </footer>
    </>
   );
};

export default Dance;
